module.exports = __webpack_public_path__ + "static/media/gallary_empty_state.f7785df8.svg";